<template>
  <header :style="{backgroundColor: currentColor}">
    <div class="titleWrapper">
      <TitleSVG
        class="title-svg"
        :class="{'invert' : this.invert}"
        @click="closeAll"
      />
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TitleSVG from '@/../public/svg/brehm-title.svg';

export default {
  components: {
    TitleSVG,
  },
  data() {
    return {
      invert: false,
    };
  },
  computed: {
    ...mapGetters(['currentColor']),
  },
  methods: {
    ...mapActions(['setRoomIndex', 'setPlayerActive', 'setInfoActive', 'resetNavigation']),
    closeAll() {
      this.setPlayerActive(false);
      this.setInfoActive(false);
      if (process.env.VUE_APP_DEBUG === 'on') console.log(' from Header ');

      this.$nextTick().then(() => {
        this.resetNavigation();
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from Header ');
      });
    },
  },
  beforeUpdate() {
    this.invert = this.$helper.isBrightHSL(this.currentColor);
  },
};
</script>

<style lang="scss">
header {
  position: fixed;
  top: 0;
  display: block;
  width: 100vw;
  height: 14vh;
  height: calc(var(--vh, 1vh) * 14);
  background-color: #eee;
  background-color: var(--main-background-color);
  background-color: var(--theme-color);
  transition: background-color .5s ease;

  display: flex;
  justify-content: center;
  align-items: center;

  .titleWrapper {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;

    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .title-svg {
    height: 7vh;
    height: calc(var(--vh, 1vh) * 7);
    max-width: 70vw;
    min-height: 30px;
    fill: var(--main-text-color-invert);
    /* fill: var(--main-text-color); */
    margin-top: 2vh;
    margin-top: calc(var(--vh, 1vh) * 2);

    svg {
      height: 100%;
      width: 100%;
    }

    &.invert {
      fill: var(--main-text-color);
    }
  }
  @media (prefers-color-scheme: dark) {
    .title-svg {
      &.invert {
        fill: var(--main-text-color-invert);;
      }
    }
  }
}
@media only screen and (orientation : portrait)
 and (min-aspect-ratio: 4/9)
 and (max-height : 700px) {
  header {
    .titleWrapper {
    }
    .title-svg {
      height:10vh;
      height: calc(var(--vh, 1vh) * 10);
      max-width: 33vw;
      min-height: 23px;
      margin: 0;
    }
  }
}
@media only screen and (orientation : landscape) {
  header {
    height: 14vh;
    height: calc(var(--vh, 1vh) * 14);
    display: flex;
    justify-content: center;
    align-items: center;

    .titleWrapper {
      position: relative;
    }

    .title-svg {
      height:10vh;
      height: calc(var(--vh, 1vh) * 10);
      min-height: 23px;
      margin: 0;
    }
  }
}
</style>
